import React, { useEffect } from "react";
import { useRecoilState } from 'recoil';
import EnodBeaconClient from "../../clients/EnodBeaconClient";
import stateDiseases from '../../state/stateDiseases';
import statePhenotypes from '../../state/statePhenotypes';
import stateEnodProjects from '../../state/stateEnodProjects';


function useBeaconFilters() {
    const [diseases, setDiseases] = useRecoilState(stateDiseases);
    const [phenotypes, setPhenotypes] = useRecoilState(statePhenotypes);
    const [enodProjects, setEnodProjects] = useRecoilState(stateEnodProjects);

    useEffect(() => {
        if (0 === diseases.length && 0 === phenotypes.length && 0 === enodProjects.length) {
            const abortController = new AbortController();
            (async () => {
                try {
                    const filteringTerms = await EnodBeaconClient.getFilteringTerms(abortController.signal);
                    const phenotypes = filteringTerms.filter((elem) => "HPO" === elem.type);
                    const diseases = filteringTerms.filter((elem) => "ICD10" === elem.type);
                    const enodProjects = filteringTerms.filter((elem) => "ENOD" === elem.type);
                    setPhenotypes(phenotypes);
                    setDiseases(diseases);
                    setEnodProjects(enodProjects);
                } catch (error) {
                    if (!abortController.signal.aborted) {
                        // error!
                        console.log("ERROR: " + error);
                    }
                }
            })();
            /*
            const options = {
                method: 'GET',
                mode: 'cors',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                signal: abortController.signal
            } as RequestInit;
            (async () => {
                try {
                    const rawResponse = await fetch("http://iva-enod.clinbioinfosspa.es:8080/ga4gh-beacon-v2/filtering_terms?limit=999", options);
                    const response = await rawResponse.json();
                    const filteringTerms = ((response.response || {}).filteringTerms || []) as any[];
                } catch (error) {
                    if (!abortController.signal.aborted) {
                        // error!
                        console.log("ERROR: " + error);
                    }
                }
            })();
            */
            return () => {
                abortController.abort();
            };
        } else {
            return () => {};
        }
    }, [diseases, phenotypes, enodProjects]);
}

export default useBeaconFilters;
